const session_expired = {
    title: 'Session expired',
    subtitle: 'Your session might have expired and you have been disconnected. Click the button below to sign in to admin console again.',
    button: 'Sign in again',
};
export default Object.freeze(session_expired);
